import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { Stars, TierBadge, VerifiedBadge } from "./Badges";

export default function PluginCard({ plugin }) {
  const Icon = Icons[plugin.icon] || Icons.Puzzle;
  return (
    <Link
      to={`/plugin/${plugin.slug || plugin.id}`}
      className="group aurora-on-hover block relative border border-white/5 p-6 bg-surface/40 backdrop-blur-md rounded-2xl transition-all duration-300 hover:bg-white/5 hover:border-accent/40 hover:-translate-y-1.5 hover:shadow-[0_15px_40px_-10px_rgba(56,189,248,0.2)] overflow-hidden m-2"
      data-testid={`plugin-card-${plugin.slug || plugin.id}`}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-white/[0.03] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
      <div className="flex items-start gap-4 mb-4 relative z-10">
        <div className="w-12 h-12 border border-white/10 bg-bg/80 rounded-xl flex items-center justify-center shrink-0 group-hover:border-accent/60 group-hover:shadow-[0_0_15px_rgba(56,189,248,0.4)] transition-all duration-300">
          <Icon size={20} strokeWidth={1.5} className="text-accent group-hover:scale-110 transition-transform duration-300" />
        </div>
        <div className="min-w-0 flex-1 pt-0.5">
          <div className="font-display font-medium text-base text-white truncate">{plugin.name}</div>
          <div className="flex items-center gap-1.5 text-xs font-mono text-text2 truncate mt-1">
            <span className="truncate group-hover:text-white/80 transition-colors">{plugin.author_name}</span>
            {plugin.author_verified && <VerifiedBadge />}
          </div>
        </div>
        <TierBadge tier={plugin.tier} />
      </div>

      <p className="font-body text-sm text-text2 leading-relaxed line-clamp-2 min-h-[40px] mb-5 relative z-10 group-hover:text-text1 transition-colors duration-300">
        {plugin.short_description}
      </p>

      <div className="flex items-center justify-between text-xs font-mono text-text2 relative z-10 pt-4 border-t border-white/5 group-hover:border-white/10 transition-colors">
        <div className="flex items-center gap-3">
          <span className="flex items-center gap-1.5">
            <Stars value={plugin.rating_avg || 0} size={12} />
            <span className="font-medium text-white/90">{(plugin.rating_avg || 0).toFixed(1)}</span>
            <span className="text-text2/50">({plugin.rating_count || 0})</span>
          </span>
          <span className="text-white/10">·</span>
          <span className="group-hover:text-white/80 transition-colors">{plugin.downloads || 0} installs</span>
        </div>
        <span className="uppercase tracking-wider font-semibold text-accent/90">
          {plugin.price_usd > 0 ? `$${plugin.price_usd.toFixed(2)}` : "Free"}
        </span>
      </div>
    </Link>
  );
}
